// nftUtils.js
import { getmarketItem, getDataFromURI } from "../../hooks/Tokenhook"; // Adjust the import paths accordingly
import { GetLike } from "../../hooks/Likehook"; // Adjust the import paths accordingly
import { SingleUserDetails, getUserByAddress } from "../../hooks/User";
import { getmarketItemOfCollection } from "../../hooks/Collectionhook";
import { getAllNFTs } from "../../hooks/LazyMinting";
import { GetAllAuctionOfAuction } from "../../hooks/AuctionHook";
const userId = localStorage.getItem("userId");
const walletAddress = localStorage.getItem("WalletAddress");

export const loadNFTs = async (contractAddress) => {
  try {
    const response = await getmarketItem();
    const NFTs = response.data;
    const updatedNFTs = await Promise.all(
      NFTs.map(async (item) => {
        let UserLike = [];
        let UserData = {};
        if (userId !== undefined) {
          UserLike = item.likeby.filter((data) => data.userId === userId);
          await getUserByAddress(item.creator).then((value) => {
            const Data = value.user;
            UserData = Data;
          });
        }
        // if (res.status === 200) {
        const data = item.metadata;
        return {
          ...item,
          title: data.title,
          image: data.image,
          type: data.type,
          category: data.category,
          desc: data.desc,
          tokenId: item.tokenId,
          tokenURI: item.tokenURI,
          creator: item.creator,
          seller: item.seller,
          listed: item.listed,
          price: item.price,
          totalLikes: item.totalLikes,
          attributes: data.attributes || [],
          properties: data.properties || [],
          creatorName: UserData !== undefined ? UserData.name : "---",
        };
        // }
        // return item; // Return the original item if res.status is not 200
      })
    );
    return updatedNFTs;
  } catch (error) {
    console.error("Failed to load NFTs", error);
    return []; // Return an empty array on error
  }
};

export const loadAllNFTs = async (page, limit) => {
  try {
    const response = await getAllNFTs(page, limit);
    const NFTs = response.data;
    const updatedNFTs = await Promise.all(
      NFTs.map(async (item) => {
        return {
          ...item,
          title: item.metadata?.title,
          image: item.metadata?.image,
          type: item.metadata?.type,
          category: item.metadata?.category,
          desc: item.metadata?.desc,
          tokenId: item.tokenId,
          tokenURI: item.tokenURI,
          creator: item.creator,
          seller: item.seller,
          listed: item.listed,
          price: item.price,
          totalLikes: item.totalLikes,
          attributes: item.metadata?.attributes || [],
          properties: item.metadata?.properties || [],
        };
      })
    );

    return {
      ...response,
      data: updatedNFTs,
    };

    // const shuffled = NewUpdatedArray.sort(() => Math.random() - 0.5);
  } catch (error) {
    console.error("Failed to load NFTs", error);
    return []; // Return an empty array on error
  }
};

export const loadNFTsForaCollection = async (contractAddress) => {
  try {
    const response = await getmarketItemOfCollection(contractAddress);
    const NFTs = response.data;
    const updatedNFTs = await Promise.all(
      NFTs.map(async (item) => {
        const res = await getDataFromURI(item.tokenURI);
        let UserData = {};
        if (userId !== undefined) {
          // UserLike = likeData.filter((data) => data.userId === userId);
          await getUserByAddress(item.owner).then((value) => {
            const Data = value.user;
            UserData = Data;
          });
        }
        if (res.status === 200) {
          const data = res.data;
          return {
            ...item,
            title: data.title,
            image: data.image,
            type: data.type,
            category: data.category,
            desc: data.desc,
            // isLike: UserLike.length !== 0,
            tokenId: item.tokenId,
            tokenURI: item.tokenURI,
            creator: item.creator,
            seller: item.seller,
            listed: item.listed,
            price: item.price,
            creatorprofilePicture:
              UserData !== undefined ? UserData.profilePicture : null,
            // totalLikes: like.totalLikes,
            attributes: data.attributes || [],
            properties: data.properties || [],
            creatorName: UserData !== undefined ? UserData.name : "",
          };
        }
        return item; // Return the original item if res.status is not 200
      })
    );
    return updatedNFTs;
  } catch (error) {
    console.error("Failed to load NFTs", error);
    return []; // Return an empty array on error
  }
};

export const loadLiveNFTCollection = async (contractAddress) => {
  try {
    const response = await GetAllAuctionOfAuction(contractAddress);
    const NFTs = response.data;
    const updatedNFTs = await Promise.all(
      NFTs.map(async (item) => {
        const res = await getDataFromURI(item.tokenURI);
        // const like = await GetLike(contractAddress, item.tokenId);
        // const likeData = like.likes;
        // let UserLike = [];
        let UserData = {};
        if (userId !== undefined) {
          // UserLike = likeData.filter((data) => data.userId === userId);
          await getUserByAddress(walletAddress).then((value) => {
            const Data = value.user;
            UserData = Data;
          });
        }
        if (res.status === 200) {
          const data = res.data;
          const myDate = new Date(item.endTime * 1000);
          return {
            ...item,
            title: data.title,
            image: data.image,
            type: data.type,
            category: data.category,
            desc: data.desc,
            // isLike: UserLike.length !== 0,
            tokenId: item.tokenId,
            tokenURI: item.tokenURI,
            creator: item.creator,
            seller: item.seller,
            highestBid: item.highestBid,
            endTime: myDate.toLocaleString(),
            listed: item.listed,
            price: item.price,
            creatorprofilePicture:
              UserData !== undefined ? UserData.profilePicture : null,
            // totalLikes: like.totalLikes,
            attributes: data.attributes || [],
            properties: data.properties || [],
            creatorName: UserData !== undefined ? UserData.name : "",
          };
        }
        return item; // Return the original item if res.status is not 200
      })
    );
    return updatedNFTs;
  } catch (error) {
    return []; // Return an empty array on error
  }
};
